import Cookies from "universal-cookie";
import { getCookieDomain } from "@pepdirect/v3/helpers/cookieDomain";
import { CartFragment } from "services/graphql/generated";
import { endpoints, cookies, decovoShopAppId } from "config";

const appId = decovoShopAppId;
const cookie = new Cookies();

const getCookieOptions = () => {
  const domain = getCookieDomain();

  return {
    path: "/",
    ...(domain ? { domain } : {}),
    secure: cookies.secureCookie,
    maxAge: 365 * 24 * 60 * 60,
  };
};

export const getCartIdFromCookie = () => cookie.get(cookies.cartCookieName);

export const saveCartCookie = (id: string) => {
  // Attempt to remove the cookie set w/o a proper domain first,
  // otherwise the set will fail.
  cookie.remove(cookies.cartCookieName);
  cookie.set(cookies.cartCookieName, id, getCookieOptions());
};

export const deleteCartCookie = () => {
  cookie.remove(cookies.cartCookieName, getCookieOptions());
  // Attempt to remove cookies that may have been set on the wrong domain
  cookie.remove(cookies.cartCookieName);
};

export const getCheckoutUrl = (): string =>
  `${endpoints.checkout}/v3/${getCartIdFromCookie()}/${appId}`;

export const getSubtotal = (cart: CartFragment | null): number => {
  if (!cart?.variantItems?.length) return 0;

  return (
    cart.variantItems.reduce((subtotal, item) => {
      if (item?.variant?.price) {
        return subtotal + item.variant.price * item.quantity;
      } else {
        return subtotal;
      }
    }, 0) / 100
  );
};

// returns true if at least 1 item has a subscription
export const cartHasSubscriptionItem = (cart: CartFragment): boolean => {
  return (
    cart?.variantItems?.some((item) => item?.subscriptionIntervalInDays) ??
    false
  );
};
